import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { api } from "@/lib/site";
import { inp } from "./ui";

const STATUS = { queued: "Čaká", running: "Prebieha", done: "Hotovo", error: "Chyba" };

export const ImportAdmin = () => {
  const [url, setUrl] = useState("");
  const [jobs, setJobs] = useState([]);
  const load = () => api.get("/admin/imports").then((r) => setJobs(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  const active = jobs.some((j) => j.status === "queued" || j.status === "running");
  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (!active) return undefined;
    const id = setInterval(load, 2500);
    return () => clearInterval(id);
  }, [active]);
  const start = async () => {
    try { await api.post("/admin/imports", { url }); setUrl(""); toast.success("Import spustený"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Import sa nepodarilo spustiť"); }
  };
  return (
    <div data-testid="admin-import" className="max-w-3xl">
      <h2 className="font-display text-3xl text-midnight mb-3">Import feedu</h2>
      <p className="text-sm text-midnight/70 mb-6">Vložte odkaz na XML alebo JSON feed. Nehnuteľnosti sa stiahnu aj s fotografiami a uložia sa ako <b>skryté</b> do záložky Nehnuteľnosti – tam ich skontrolujete a zverejníte. Opakovaný import rovnakého feedu pridá len nové nehnuteľnosti.</p>
      <div className="flex flex-col sm:flex-row gap-3">
        <input className={inp} value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://portal.sk/export/feed.xml" data-testid="import-url" />
        <button onClick={start} disabled={!url || active} className="btn-gold shrink-0" data-testid="import-start"><Download size={14} /> Importovať</button>
      </div>
      <div className="mt-8 space-y-3">
        {jobs.map((j) => (
          <div key={j.id} className="bg-white border border-sand/60 p-4" data-testid={`import-job-${j.id}`}>
            <div className="flex justify-between gap-4 text-sm">
              <span className="truncate text-midnight">{j.url}</span>
              <span className={`shrink-0 ${j.status === "error" ? "text-red-600" : j.status === "done" ? "text-green-700" : "text-gold"}`}>{STATUS[j.status] || j.status}</span>
            </div>
            <div className="text-xs text-midnight/60 mt-2">
              Spracované {j.processed || 0}/{j.total || 0} · nové {j.created || 0} · preskočené {j.skipped || 0}{j.failed_images ? ` · nestiahnuté fotky ${j.failed_images}` : ""}
            </div>
            {j.total > 0 && <div className="h-1 bg-sand/40 mt-2"><div className="h-full bg-gold transition-[width] duration-500" style={{ width: `${Math.round(((j.processed || 0) / j.total) * 100)}%` }} /></div>}
            {j.error && <p className="text-xs text-red-600 mt-2">{j.error}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};
